export var ToastSkin;
(function (ToastSkin) {
    ToastSkin["status"] = "status";
    ToastSkin["success"] = "success";
    ToastSkin["error"] = "error";
    ToastSkin["preview"] = "preview";
})(ToastSkin || (ToastSkin = {}));
export var ToastPlacement;
(function (ToastPlacement) {
    ToastPlacement["inline"] = "inline";
    ToastPlacement["bottomFullWidth"] = "bottomFullWidth";
})(ToastPlacement || (ToastPlacement = {}));
//# sourceMappingURL=types.js.map